// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X6Zj","title":"styles_title__2t3Fl"};